import cn from 'classnames';
import { useUnit } from 'state/unit';
import useFormattable, { Formattable } from '../formattable';
import styles from './EpisodeDescription.module.scss';

export interface EpisodeDescriptionProps extends Formattable<string> {
  className?: string;
}

const EpisodeDescription: React.FC<EpisodeDescriptionProps> = (props) => {
  const { className } = props;

  const unit = useUnit();
  const formattedValue = useFormattable(unit?.episode?.description, props);

  return !unit ? null : (
    <span className={cn(styles.root, className)}>{formattedValue}</span>
  );
};

export default EpisodeDescription;
